import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ForgotpasswordModule } from './forgotpassword/forgotpassword.module';
import { CheckboxModule } from 'primeng/checkbox';
import { ExternalLoginComponent } from './external-login/external-login.component';


@NgModule({
  declarations: [LoginComponent, ExternalLoginComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    NgxSpinnerModule,
    ForgotpasswordModule,
    CheckboxModule,
  ],
  exports: [LoginComponent],
})
export class AuthenticationModule {}
